import { render } from "./TownClerkLogo.vue?vue&type=template&id=527d6053"
import script from "./TownClerkLogo.vue?vue&type=script&lang=js"
export * from "./TownClerkLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__